module.exports = __webpack_public_path__ + "fb38234e1896a0811c470c53a5f94569.png";